var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKinesis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(7 4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCBF92",
    points: "0 22.404 16.632 30.06 33.264 22.404 16.632 21.714"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9D5025",
    points: "16.683 0 .008 8.317 .008 20.051 20.003 20.051 20.003 1.659"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCBF92",
    points: ".008 28.324 16.693 40.128 33.327 28.324 16.656 25.898"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9D5025",
    transform: "translate(16.67 6.494)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: ".013 13.557 8.81 13.557 8.81 1.035 6.241 .008 .013 1.825"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.241 13.557 13.041 13.557 13.041 5.435 11.096 4.852 6.241 5.676"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.096 4.215 11.096 13.557 16.593 13.557 16.658 4.174 14.988 3.507"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F68534",
    d: "M16.68281,0 L16.68281,20.0510564 L20.0029864,20.0510564 L20.0029864,1.6594612 L16.68281,0 Z M25.4804623,7.52943942 L22.9114325,6.50199468 L22.9114325,20.0510564 L25.4804623,20.0510564 L25.4804623,7.52943942 Z M29.7114614,11.9293106 L27.766506,11.3457822 L27.766506,20.0514744 L29.7114614,20.0514744 L29.7114614,11.9293106 Z M31.6580888,20.0510564 L33.327582,20.0510564 L33.327582,10.6673677 L31.6580888,10.0002392 L31.6580888,20.0510564 Z M16.632232,24.0667853 L16.632232,30.0596556 L33.263628,25.9139287 L33.263628,22.4035621 L16.632232,24.0667853 Z M16.632232,34.2108166 L16.632232,40.1280289 L33.327164,31.7805629 L33.327164,28.3237004 L16.632232,34.2108166 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    d: "M0.00752400542,31.8165109 L16.632232,40.1280289 L16.632232,34.1673446 L0.00836000602,28.3232824 L0.00752400542,31.8165109 Z M0,25.9139287 L16.632232,30.0596556 L16.632232,24.0667853 L0,22.4031441 L0,25.9139287 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKinesis);
export default __webpack_public_path__ + "static/media/Kinesis.f89a5eff.svg";
export { ForwardRef as ReactComponent };